export default "__VITE_ASSET__B8H2Z0wm__$_?nuxt_component=async&nuxt_component_name=IconFooterPaymentPaypalInstant&nuxt_component_export=default__"